import { useEffect, useState } from "react";
import { getTasksByProjectId, Tasking } from "./useTask"; 
import { useAuthToken } from "../data/redux/useAuthToken";

export const useTaskInfo = (projectId: string) => {
  const [tasks, setTasks] = useState<Tasking[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const empToken = useAuthToken();


  const fetchTasks = async () => {
    if (!projectId) return;
    setLoading(true);
    setError(null);
    try {
      const data = await getTasksByProjectId(empToken,projectId);
      setTasks(data);
    } catch (err: any) {
      setError("Failed to fetch tasks");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTasks();
  }, [empToken,projectId]);

  return {
    tasks,
    loading,
    error,
    refreshTasks: fetchTasks,
  };
};
